import React from 'react'
import Sortable from 'react-sortablejs'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faGripLines } from '@fortawesome/pro-regular-svg-icons/faGripLines'
import styled from '@emotion/styled'

const SortableRow = styled.div`
    cursor: grab;
    background-color: #666;
    border-bottom: 1px solid;
    padding: 10px 15px;
    border-radius: 3px;

    &:last-child {
        border-bottom: none;
    }

    &:active {
        cursor: grabbing;
        background-color: #888;
    }
`

const AccordionItemSort = ({ accordion, onChange }) => (
    <Sortable
        onChange={(order, sortable, evt) => {
            const items = [...accordion]
            const [movedItem] = items.splice(evt.oldIndex, 1)
            items.splice(evt.newIndex, 0, movedItem)
            onChange({ accordion: items })
        }}
        options={{
            animation: 100,
        }}
    >
        {accordion.map((item, idx) => (
            <SortableRow key={idx} data-id={idx}>
                <FontAwesomeIcon icon={faGripLines} className="!mr-2" /> {item.label}
            </SortableRow>
        ))}
    </Sortable>
)

export default AccordionItemSort
